import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";


export default {
    namespaced: true,
    state: {
        medicines: [],
        medicine: {
            id: null,
            medicineName: null,
            medicineType: null,
            dosage: null,
            departmentName: null,
            description: null,
            createdBy: null,
            createdOn: null,
            status: null,
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.medicines.findIndex(i => i.id === id)
    },
    mutations: {
        SetItems: (state, data) => state.medicines = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SetItem: (state, viewData) => state.medicine = viewData,
        ADD: (state, addedData) => state.medicines.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.medicines.splice(index, 1, updateData),
        DELETE: (state, index) => state.medicines.splice(index, 1),
    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                const response = await dataService.medicines.getAll(paramsString);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SetItems', response.data.medicines);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            startLoading()
            try {
                commit('SetItem', {});
                const response = await dataService.medicines.getDetails(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SetItem', response.data.medicine);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        }, 
         async getForEdit(_, id) {
            startLoading()
            try {
                const response = await dataService.medicines.getForEdit(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.medicine);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
       

        async add({ commit }, payload) {
            startLoading()
            try {
                const response = await dataService.medicines.add(payload);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);
                commit('ADD', response.data.medicine);
            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        async edit({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.medicines.edit(id,payload);

                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.medicine });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        async delete({ commit, getters }, id) {
            startLoading()
            try {
                const response = await dataService.medicines.delete(id);

                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('DELETE', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
    },
};
